import * as React from "react";
import {
  Link as RouterLink,
} from "react-router-dom";
import { Link as RebassLink } from "rebass";

const Link = (props) => <RebassLink {...props} as={RouterLink} />;

export default Link;
